import { render } from "./CategoryPostFinish.vue?vue&type=template&id=07d26284"
import script from "./CategoryPostFinish.vue?vue&type=script&lang=js"
export * from "./CategoryPostFinish.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__